<script setup lang="ts">
    const { isLoading, loading, load } = useLoadingScreen(useRoute());

    onMounted(async () => {
        if (load) {
            await load();
        }
    });
</script>

<template>
    <div class="">
        <transition
            leave-active-class="duration-300 ease-in"
            leave-from-class="opacity-100 blur-none"
            leave-to-class="opacity-0 blur-xl"
        >
            <LayoutLoadingScreen
                v-if="isLoading"
                :loading="loading"
            />
        </transition>
        <template v-if="!isLoading">
            <slot />
        </template>
    </div>
</template>
